export default __webpack_public_path__ + "static/media/Farmer-website.6425256b.jpg";